import React from "react";

const AboutUs = ({ onClose }) => {
  return (
    <div
      style={{
        padding: "20px",
        borderRadius: "12px",
        maxHeight: "70vh",
      }}
    >
      {/* Optional Close Button (falls im Modal verwendet) */}
      {onClose && (
        <button
          onClick={onClose}
          style={{
            float: "right",
            border: "none",
            background: "transparent",
            fontSize: "20px",
            cursor: "pointer",
          }}
        >
          ×
        </button>
      )}

      <h1
        style={{
          fontSize: "24px",
          fontWeight: "bold",
          color: "#1b96e3",
          marginBottom: "1rem",
        }}
      >
        The Bambkuss Story
      </h1>

      <div style={{ lineHeight: "1.6", color: "#333" }}>
        <p>
          We are a small, highly motivated start-up project team from Germany. 
          We have known each other since school. However, back then we had other 
          things on our minds than computer projects. Almost everyone had a profile 
          on social networks at that time. But coming up with our own and developing 
          it over time was simply unimaginable!
        </p>

        <p>
          But it was precisely this almost unimaginable idea that brought us back 
          together years after finishing school.
        </p>

        <p>
          During the pandemic, I started making drawings that represented my thoughts 
          about a possible social network. These drawings didn't look professional, 
          but when I explained what they were about and what they meant, my future 
          team members and former schoolmates were quickly enthusiastic.
        </p>

        <p>
          Calls quickly arose that the drawings should not be the end result. In fact, 
          we managed to convert the drawings into computer graphics, which served as a 
          template for the subsequent graphic design.
        </p>

        <p>
          The graphic design and subsequent simulation took a lot of time overall because 
          we had to teach ourselves how to do it. Learning by doing was the way to go, 
          which was particularly difficult at the beginning! Once we succeeded at something, 
          it was so much fun and enjoyable that it motivated us to keep going.
        </p>

        <p>
          Over time, Bambkuss took on concrete shape, form, and contours, both visually 
          and in terms of content. The simulation served as a template for the programming 
          that ultimately brought Bambkuss to life.
        </p>

        <p>
          Now we would be delighted to convince you and many others to join us and welcome 
          you soon at <strong>Bambkuss.com</strong>!
        </p>

        <p>
          We are incredibly excited about this new challenge and hope that as many people 
          as possible will become part of Bambkuss!
        </p>

        <p>
          Together, we hope to be successful and grow in the future to become an integral 
          part of the social media world.
        </p>
      </div>
    </div>
  );
};

export default AboutUs;
